import Page from "./Page";

import "./App.css";

function App() {
  return <Page />;
}

export default App;
